module.exports = __webpack_public_path__ + "media/images/new/avatar-mikemeh-de75997074d8e4119f79e8279369171d.png";